import { render, staticRenderFns } from "./page-verify.vue?vue&type=template&id=c0ddb196&scoped=true"
import script from "./page-verify.vue?vue&type=script&lang=js"
export * from "./page-verify.vue?vue&type=script&lang=js"
import style0 from "./page-verify.vue?vue&type=style&index=0&id=c0ddb196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ddb196",
  null
  
)

export default component.exports